import { connect } from 'react-redux';
import { Store, asyncActions, facetsActions, searchParameterActions } from "dw_azsearchstore";
import * as redux from "redux";
import Results from "../components/results/Results";
import { FacetsAction } from 'dw_azsearchstore/dist/actions/facetsActions';
import { SearchParametersAction } from 'dw_azsearchstore/dist/actions/searchParametersActions';
import i18n from '../i18n';

function getReturnType<RT>(expression: (...params: any[])=>RT): RT {
    return {} as RT;
}        

function mapStateToProps(state: Store.SearchState) {
    return {
        results: state.results.results,
        total: state.results.count,
        facets: state.facets.facets,
        searchInput: state.parameters.input,
        searchParameters: state.parameters.searchParameters,
        isFetching: state.results.isFetching
    }
}

const getLanguageFullName = () => {
    let lang: React.ReactText = "English";
    switch (i18n.language){
        case "es": lang = "Spanish"; break;
        case "fr": lang = "French"; break;
        case "de": lang = "German"; break;
    }
    return lang; 
}

const mapDispatchToProps = (dispatch: redux.Dispatch<FacetsAction | SearchParametersAction>) => {
    return{
        addFilter: (facetKey: string, value: string) => {
            dispatch(facetsActions.clearFacetsSelections());
            dispatch(facetsActions.toggleCheckboxFacetSelection(facetKey, value));
            dispatch(facetsActions.toggleCheckboxFacetSelection("Language", getLanguageFullName()));
            dispatch(searchParameterActions.updateSearchParameters({skip: 0}));
            dispatch(asyncActions.fetchSearchResultsFromFacet);
            window.scrollTo({top: 0, behavior: "smooth"});
        },
        loadMore: () => {
            dispatch(searchParameterActions.incrementSkip());
            dispatch(asyncActions.loadMoreSearchResults);
        }
    }
}

export const stateProps = getReturnType(mapStateToProps);
export const dispatchProps = getReturnType(mapDispatchToProps);

export type PropsType = typeof stateProps & typeof dispatchProps;
type State = {};

const ResultsContainer = connect(mapStateToProps, mapDispatchToProps)(Results);

export {ResultsContainer};